module.exports = __webpack_public_path__ + "img/banner-hog.903f8237.png";